// extracted by mini-css-extract-plugin
export var columnList = "_g1-0";